// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1__sX","cls2":"PostEngagementFollowPrompt-cls2_Pui PostEngagementFollowPrompt-cls1__sX"};